import {
  ErrorHandler,
  inject,
  LOCALE_ID,
  NgModule,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TokenInterceptor } from './shared/interceptors/token.interceptor';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { SharedModule } from './shared/shared.module';
import { SharedMaterialModule } from './shared/shared-material.module';
import { CommonModule } from '@angular/common';
import { StateModule } from './state/state.module';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import ptBr from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';

import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
  annotationPlugin,
  ChartDataLabels
);


registerLocaleData(ptBr);

@NgModule({
  declarations: [
    AppComponent,
  ],
  bootstrap: [AppComponent], imports: [CommonModule,
    BrowserModule,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    SharedMaterialModule,
    StateModule], providers: [
    provideCharts(withDefaultRegisterables()),
    provideAnimationsAsync(),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false
      })
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    provideAppInitializer(() => {
      const traceService = inject(Sentry.TraceService);
      return Promise.resolve(traceService);
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({
      eventCoalescing: true,
      runCoalescing: true
    }),
  ]
})
export class AppModule {
  constructor() {
      ModuleRegistry.registerModules([AllCommunityModule]);
  }
}
